import {FormikProps} from 'formik';
import {IDirectDocsForm} from './formDetails';
import {ChangeEvent} from 'react';
import InputField from '../../../../../components/simpleInput';
import {ShowFormError} from '../../../../../utilities/helper/showFormError';

interface IProps {
  form: FormikProps<IDirectDocsForm>;
}

const BankAccountNumberInput = ({form}: IProps) => {
  return (
    <>
      <InputField
        name="bankAccountNumber"
        label="شماره حساب بانکی"
        required
        type="number"
        placeholder="شماره حساب بانکی را وارد کنید"
        value={form.values.bankAccountNumber || ''}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          form?.setFieldValue('bankAccountNumber', e.target.value);
        }}
      />

      <div className="flex items-center gap-1 mt-2 text-gray-600">
        <i className="icon-namereport text-md" />
        <span className="text-sm">
          شماره حساب بانکی که قصد دارید از آن وام بگیرید
        </span>
      </div>

      <ShowFormError field="bankAccountNumber" form={form} />
    </>
  );
};

export default BankAccountNumberInput;
